export const getFilterStyle = () => ({
  popoverContainer: {
    position: 'relative',
  },
});

export const getSearchFieldStyle = () => ({
  container: {
    paddingTop: 22,
    display: 'flex',
  },
});

export const getRootStyles = () => ({
  stockImageRoot: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
});
